import type { ThemeTokens } from "@yamada-ui/core"

export const fontWeights: ThemeTokens = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
}
